module.exports = __webpack_public_path__ + "static/media/decimal-point-sample-1.7df70291.png";